import 'jquery-stickytabs/jquery.stickytabs';

$(document).ready(() => {
    $('[data-microsite-tab-nav]').stickyTabs();
});